export enum Direction {
  RTL = 'rtl',
  LTR = 'ltr'
}

export interface IRootState {
  registeredModules: string[];
  locale: string;
  direction: Direction;
  hideIgentifyLogo: boolean;
  isLoggedIn: boolean;
  supportsLandscapeWarning: boolean;
}

export enum MutationTypes {
  MODULE_REGISTERED = 'MODULE_REGISTERED',
  TRANSLATIONS_LOADING = 'TRANSLATIONS_LOADING',
  SET_LOCALE = 'SET_LOCALE',
  SET_DIRECTION = 'SET_DIRECTION',
  SET_HIDE_IGENTIFY_LOGO = 'SET_HIDE_IGENTIFY_LOGO',
  SET_IS_LOGGED_IN = 'SET_IS_LOGGED_IN',
  SET_DOCUMENTS_CONFIG = 'SET_DOCUMENTS_CONFIG',
  SET_SUPOORTS_LANDSCAPE_WARNING = 'SET_SUPOORTS_LANDSCAPE_WARNING',
}
